import { couponFormService } from '../services';

export const createCoupon = async (data: AnyObject) => {
  return await couponFormService.createCupon(data);
};
